import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/hero-slide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/news.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/ScrollAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/shopLetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/TextBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/home-page/body/WidgetSpinner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Preloader.tsx");
